
import React, { useMemo, useState } from 'react';
import { Formik, Field, Form, useFormik, FormikProvider } from 'formik';
import { FormGroup, Label, Col, Row, Input } from 'reactstrap';
import CustomSelect from 'Custom/CustomSelect';
import * as Yup from 'yup'; // Don't forget to import Yup
import ListOfInvoice from './listOfInvoice';
import { POST_VendorInvoice, POST_VendorPaymentCreate } from 'helpers/url_helper';
import { post } from 'helpers/api_helper';
import CustomFlatpickr from 'Custom/CustomFlatpicker';
import NodataImage from 'assets/images/nodata/no data invoice.webp'
import { useNavigate } from 'react-router-dom';

const validationSchema = Yup.object().shape({
  contact_id: Yup.number().when('payment_mode', {
    is: 'Cheque',
    then: Yup.number().notOneOf([0], 'Vendor is required'),
    otherwise: Yup.number().notRequired()
  }),
  payment_date: Yup.date().required('Date is required'),
  payment_mode: Yup.string().required('Payment method is required'),
  payment_amount: Yup.number().positive('Amount must be a positive number').required('Amount is required'),
  cheque_no: Yup.string().when('payment_mode', {
    is: 'Cheque',
    then: Yup.string().required('Cheque number is required'),
    otherwise: Yup.string().notRequired()
  }),
  cheque_date: Yup.date().when('payment_mode', {
    is: 'Cheque',
    then: Yup.date().required('Cheque date is required'),
    otherwise: Yup.date().notRequired()
  }),
  payment_ref: Yup.string('Payment reference is required').required('Payment reference is required'),
});

const initialValues = {
  contact_id: 0,
  payment_date: '',
  payment_mode: 'Bank Transfer',
  is_balance_only: false,
  payment_amount: '',
  cheque_no: '',
  cheque_date: '',
  payment_ref: '',
  organization_id: 1,
  payfull: false
};

const paymentOptions = [
  { value: 'Cash', label: 'Cash' },
  { value: 'Credit Card', label: 'Credit Card' },
  { value: 'Others', label: 'Others' },
  { value: 'Online', label: 'Online' },
  { value: 'Bank Transfer', label: 'Bank Transfer' },
  { value: 'Cheque', label: 'Cheque' },
];

const FormComponent = ({ vendorOptions, setIsLoading }) => {
  const [invoices, setInvoices] = useState([])
  const navigate = useNavigate()

  const getInvoiceByVendor = async (contact_id) => {
    setIsLoading(true)
    await post(POST_VendorInvoice, { contact_id })
      .then(res => {
        if (res?.status == 200 && res?.data.length > 0) {
          setInvoices(res?.data)
        } else {
          setInvoices([])
        }
        setIsLoading(false)
      })
      .catch(error => {
        setIsLoading(false)
      })
  }

  const createPayment = async (data) => {
    setIsLoading(true)
    await post(POST_VendorPaymentCreate, data)
      .then(res => {
        if (res?.status == 200) {
          swal({
            title: "Success",
            text: res.message,
            icon: "success",
            button: "OK",
          })
          getInvoiceByVendor()
          navigate('/vendors-payment')
        } else {
          swal({
            title: "Error!",
            text: res.message?.invoice,
            icon: "error",
            button: "OK",
          })
        }
        setIsLoading(false)
      })
      .catch(error => {
        setIsLoading(false)
      })
  }

  const handleSubmit = (values) => {
    let data = { ...values }
    let payments = []
    for (let item of invoices) {
      if (item?.paymentAboutToPay) {
        payments.push({
          invoice_id: item?.v_invoice_id,
          paid_amount: item?.paymentAboutToPay
        })
      }
    }
    data['is_balance_only'] = data['is_balance_only'] ? 1 : 0
    data['invoice'] = values?.is_balance_only ? [] : payments
    createPayment(data)
  };

  const findFullAmountToPay = useMemo(() => {
    let data = [...invoices]
    let totalis = 0
    data?.map(invoice => {
      const dueAmount = parseFloat(invoice.due_amount);
      const grandTotal = parseFloat(invoice.grand_total);
      let amountToPay = dueAmount || grandTotal
      totalis = totalis + amountToPay
      return invoice
    })
    return totalis
  }, [invoices])

  const formikFilter = useFormik({
    validationSchema,
    initialValues,
    onSubmit: (values) => handleSubmit(values),
    validateOnBlur: false,
  })

  const {
    setFieldValue,
    values,
    touched,
    errors // This was missing in your original code
  } = formikFilter

  const updateInvoicePayment = (amountAboutToPay) => {
    let sumOfPayment = 0
    let data = [...invoices]
    data?.map(invoice => {
      const dueAmount = parseFloat(invoice.due_amount);
      const grandTotal = parseFloat(invoice.grand_total);
      let amountToPay = dueAmount || grandTotal
      let amountLeft = amountAboutToPay - sumOfPayment
      if (amountToPay <= amountLeft) {
        sumOfPayment = sumOfPayment + amountToPay
        invoice['paymentAboutToPay'] = amountToPay
      } else {
        sumOfPayment = sumOfPayment + amountLeft
        invoice['paymentAboutToPay'] = amountLeft
      }
      return invoice
    })
    setInvoices(data)
  }

  useMemo(() => {
    if (values?.contact_id && !values?.payfull) {
      getInvoiceByVendor(values?.contact_id)
    } if (values?.payfull) {
      setFieldValue('payment_amount', findFullAmountToPay)
      updateInvoicePayment(findFullAmountToPay)
    }
  }, [values?.contact_id, values?.payfull])

  const handlepayment = (e) => {
    let { value } = e.target
    let amountAboutToPay = Number(value)
    setFieldValue('payment_amount', amountAboutToPay)
    updateInvoicePayment(amountAboutToPay)
  }

  return (
    <FormikProvider value={formikFilter} validationSchema={validationSchema}>
      <Form onSubmit={formikFilter.handleSubmit}>
        <Row>
          <Col sm={4}>
            <FormGroup>
              <Label for="vendor">Vendor</Label>
              {vendorOptions?.length && (
                <Field
                  name="contact_id"
                  placeholder="Select Vendor Name"
                  component={CustomSelect}
                  className={touched.contact_id && errors.contact_id ? 'is-invalid' : ''}
                  options={vendorOptions}
                />
              )}
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <Label for="payment_date">Date</Label>
              <Field
                type="text"
                id="payment_date"
                name="payment_date"
                placeholder={"dd/mm/yyyy"}
                component={CustomFlatpickr}
                options={{
                  altInput: true,
                  altFormat: "d/m/Y",
                  dateFormat: "d/m/Y",
                }}
              />
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <Label for="payment_mode">Payment Method</Label>
              <Field
                name="payment_mode"
                placeholder="Select Payment Method"
                component={CustomSelect}
                className={touched.payment_mode && errors.payment_mode ? 'is-invalid' : ''}
                options={paymentOptions}
              />
            </FormGroup>
          </Col>
          <Col sm={2}>
            <FormGroup check>
              <Label for="is_balance_only">Balance</Label>
              <br />
              <Field type="checkbox" name="is_balance_only" /> Is Balance Only
            </FormGroup>
            {touched.is_balance_only && errors.is_balance_only && <div className="text-danger">{errors.is_balance_only}</div>}
          </Col>
          <Col sm={4}>
            <FormGroup>
              <Label for="payment_amount">Payment amount</Label>
              <Input
                onChange={handlepayment}
                value={values?.payment_amount}
                className={`form-control ${touched.payment_amount && errors.payment_amount ? 'is-invalid' : ''}`}
                type="number"
                id="payment_amount"
                name="payment_amount"
                placeholder={"Enter Payment Amount"}
                step="0.01" // Step attribute for decimal precision
                min="0" // Minimum value allowed
              />
              <div className='mt-1'>
                <Field type="checkbox" name="payfull" /> <span>Pay Full ({findFullAmountToPay})</span>
              </div>
              {touched.payment_amount && errors.payment_amount && <div className="text-danger">{errors.payment_amount}</div>}
            </FormGroup>
          </Col>
          {values?.payment_mode === 'Cheque' && <>
            <Col sm={4}>
              <FormGroup>
                <Label for="cheque_no">DD/ Cheque Number</Label>
                <Field className={`form-control`} type="text" id="cheque_no" name="cheque_no" />
              </FormGroup>
            </Col>
            <Col sm={4}>
              <FormGroup>
                <Label for="cheque_date">DD/ Cheque Date</Label>
                <Field
                  type="text"
                  name="cheque_date"
                  placeholder={"dd/mm/yyyy"}
                  component={CustomFlatpickr}
                  options={{
                    altInput: true,
                    altFormat: "d/m/Y",
                    dateFormat: "d/m/Y",
                  }}
                />
              </FormGroup>
            </Col>
          </>}

          <Col sm={4}>
            <FormGroup>
              <Label for="payment_ref">Payment Ref</Label>
              <Field
                className={`form-control ${touched.payment_ref && errors.payment_ref ? 'is-invalid' : ''}`}
                type="text"
                id="payment_ref"
                placeholder={"Enter Payment Ref."}
                name="payment_ref"
              />
              {touched.payment_ref && errors.payment_ref && <div className="text-danger">{errors.payment_ref}</div>}
            </FormGroup>
          </Col>
          <Col sm={12} lg={12} md={12}>
            <br />
            <hr />
            {!values?.is_balance_only && <>
              {
                invoices?.length ? <ListOfInvoice
                  setFieldValue={setFieldValue}
                  setInvoices={setInvoices}
                  invoices={invoices} /> : <div style={{ minHeight: '200px' }} className='mt-2'>
                  <center>
                    <div className="position-relative">
                      <img
                        src={NodataImage}
                        alt="NodataImage"
                        height={200}
                      />
                    </div>
                    <h3>No Invoice available for select Vendor   </h3>
                  </center>
                </div>
              }
            </>}
            <br />
          </Col>
          <div className=' d-flex justify-content-end '>
            <button type="submit" className="btn btn-primary">Submit</button>
          </div>
        </Row>
      </Form>
    </FormikProvider>
  );
};

export default FormComponent;
